import { cEl } from '../../../../../util';
import rightUpGraph from '../../../../../assets/images/right-up-graph.svg';
import dollar from '../../../../../assets/images/dollar.svg';

function ScenarioSlide() {
    const scenarioSlide = cEl('article');
    scenarioSlide.classList.add('carousel-slide', 'scenario-slide');
    scenarioSlide.innerHTML = `
    <h2>비용 효율성을 높이기 위한 시나리오</h2>
    <div class="slide-item-list">
        <div class="slide-item">
            <div class="img-container">
                <img src="${rightUpGraph}" alt="right up graph" />    
            </div>
            <div>
                <div class="sub-topic">사용 빈도가 높은 시나리오</div>
                로봇의 도입 비용 대비 효율성을 위해, <span class="text-highlight">사용 빈도가 높은 업무</span>를 우선 선택하세요.        
            </div>
        </div>
        <div class="slide-item">
            <div class="img-container">
                <img src="${dollar}" alt="dollar" />
            </div>
            <div>
                <div class="sub-topic">적절한 인프라 비용</div>
                엘리베이터와 자동문 사용 시, 인프라 구축비가 커질 수 있으니 <span class="text-highlight">비용 대비 효율성을 고려</span>하세요.
            </div>
        </div>
    </div>
    `;

    return scenarioSlide;
}

export default ScenarioSlide;
